import { render, staticRenderFns } from "./Cargo.vue?vue&type=template&id=1ed56120&"
import script from "./Cargo.vue?vue&type=script&lang=js&"
export * from "./Cargo.vue?vue&type=script&lang=js&"
import style0 from "./Cargo.vue?vue&type=style&index=0&id=1ed56120&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports